import { A, useSearchParams } from "@solidjs/router";
import { Show } from "solid-js";
import { withLeadingQuestionMark } from "../../boundaries/query-string.parser";
import { MAP_PREVIEW_VIEW } from "../../enums/map";
import { FLOWS_VIEW } from "../../enums/scan";
import { singleParam } from "../../ui/searchParam";

export function mapPreviewHref(websiteId: string, returnQuery: string): string {
  const params = new URLSearchParams({
    mapView: MAP_PREVIEW_VIEW.ARCHITECTURE,
    from: "pages",
    return: returnQuery,
  });
  return `/w/${websiteId}/map?${params.toString()}`;
}

export function MapScanNavigation(props: { websiteId: string }) {
  const [search] = useSearchParams();
  const pathsRequested = () =>
    new URLSearchParams(singleParam(search.return) ?? "").get("view") ===
    FLOWS_VIEW.PATHS;
  const returnHref = () => {
    const query = singleParam(search.return);
    return `/w/${props.websiteId}/scan/pages${query ? withLeadingQuestionMark(query) : ""}`;
  };

  return (
    <div class="signal-inline-actions">
      <Show
        when={singleParam(search.from) === "pages"}
        fallback={
          <A class="scan-btn" href={`/w/${props.websiteId}/scan/pages`}>
            View current estate
          </A>
        }
      >
        <A class="scan-btn" href={returnHref()}>
          {pathsRequested()
            ? "Return to Current Paths"
            : "Return to content structure"}
        </A>
      </Show>
      <span class="map-preview-badge">Preview</span>
    </div>
  );
}
